import React from 'react';
import Collapsible from 'src/components/Collapsible/Collapsible';
import TpSlOrderForm from './TpSlOrderForm';
import { SaveTpSlOrdersCallback } from './types';
import { BigNum } from '@velocity-exchange/sdk';
import { UIOrderType } from '@velocity-exchange/common';
import { ITradeForm } from 'src/stores/VelocityStore/types/tradeForm';

interface CollapsibleTpSlOrderFormProps {
	isTpSlCheckboxChecked: boolean;
	side: 'buy' | 'sell';
	entryPrice: BigNum;
	entrySize: BigNum;
	saveBracketOrdersCallback: SaveTpSlOrdersCallback;
	orderType: UIOrderType;
	bracketOrders: ITradeForm['bracketOrders'];
}

const CollapsibleTpSlOrderForm = ({
	isTpSlCheckboxChecked,
	side,
	entryPrice,
	entrySize,
	saveBracketOrdersCallback,
	orderType,
	bracketOrders,
}: CollapsibleTpSlOrderFormProps) => {
	return (
		<Collapsible.Root open={isTpSlCheckboxChecked}>
			<Collapsible.Content className="mt-md">
				<TpSlOrderForm
					direction={side == 'buy' ? 'long' : 'short'}
					entryPrice={entryPrice}
					entrySize={entrySize}
					saveOrdersCallback={saveBracketOrdersCallback}
					savedTakeProfitPrice={bracketOrders?.takeProfit?.price}
					savedStopLossPrice={bracketOrders?.stopLoss?.price}
					orderType={orderType}
				/>
			</Collapsible.Content>
		</Collapsible.Root>
	);
};

export default React.memo(CollapsibleTpSlOrderForm);
